
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/air-freight",
      function () {
        return require("private-next-pages/services/air-freight/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/air-freight"])
      });
    }
  